import { render, staticRenderFns } from "./ComprovantesResgateDeValores.vue?vue&type=template&id=79bd9f6c&"
import script from "./ComprovantesResgateDeValores.vue?vue&type=script&lang=js&"
export * from "./ComprovantesResgateDeValores.vue?vue&type=script&lang=js&"
import style0 from "./ComprovantesResgateDeValores.vue?vue&type=style&index=0&id=79bd9f6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports